import PiBooleanProperty from "../../../components/PiProperties/PiBooleanProperty";
import PiNumberProperty from "../../../components/PiProperties/PiNumberProperty";
import type { InteractionPropertiesEditor } from "../../interaction_factory/InteractionFactory";

export const InstantSpeedPropertiesEditor: InteractionPropertiesEditor = {
  handledPropertyIds: ["instant", "speed"],
  render: (interaction, actions) => {
    const instantProperty = interaction.properties?.find(
      (property) => property.id === "instant"
    );
    const speedProperty = interaction.properties?.find(
      (property) => property.id === "speed"
    );

    if (!instantProperty) return null;

    const isInstant = Boolean(instantProperty.value);

    return (
      <div
        data-testid="interaction-behavior-settings"
        className="flex flex-col gap-[8px] pb-[8px]"
      >
        <div className="text-[12px] font-semibold uppercase tracking-[0.08em] text-creator-text-soft">
          Behavior
        </div>
        <PiBooleanProperty
          interactionProperty={instantProperty}
          onChange={actions.updateProperty}
        />
        {!isInstant && speedProperty && (
          <PiNumberProperty
            interactionProperty={speedProperty}
            onChange={actions.updateProperty}
          />
        )}
      </div>
    );
  },
};
